export function formatUnionMatchCheck() {
  return "at least one variant of the `TaggedUnion` must match";
}
